import type { CheckInType, EventStatus, PaymentMethod, SaleType } from '@linka/domain/enums';
import { createContext, type ReactNode, use } from 'react';

export interface ExportFilters {
  startDate?: string;
  endDate?: string;
  paymentMethods?: PaymentMethod[];
  ticketsIds?: string[];
  status?: EventStatus;
  type?: CheckInType;
  saleType?: SaleType;
}

export interface ExportContextValue {
  eventId: string;
  filters: ExportFilters;
  userEmail?: string;
  assets?: {
    spinner?: string;
    success?: string;
  };
}

const ExportContext = createContext<ExportContextValue | null>(null);

export interface ExportProviderProps extends ExportContextValue {
  children: ReactNode;
}

export const ExportProvider = ({ children, ...value }: ExportProviderProps) => (
  <ExportContext value={value}>{children}</ExportContext>
);

export const useExportContext = (): ExportContextValue => {
  const ctx = use(ExportContext);
  if (!ctx) throw new Error('useExportContext must be used inside <ExportProvider>');
  return ctx;
};
